var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox',{attrs:{"checked":_vm.value,"disabled":_vm.disabled,"indeterminate":_vm.indeterminate},on:{"change":_vm.change}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }